import * as Constants from './Constants';

const initialState = {
  home_line: '',
  ccAttempts: '',
  fiveg_line: '',
  isResumeFlow: '',
  regSkip: '',
  show: '',
  // count: 0,
  deliveryDate: '',
  paymentCall: '',
  showEid: '',
  isBackOrder: '',
  apiLoaded: false,
  taggingApiLoaded: false,
  signInCradleValue: '',
  apiCompleted: false,
};

function SessionValues(state = initialState, action) {
  switch (action.type) {
    case Constants.HOME_LINE:
      return { ...state, home_line: action.value };
    case Constants.CCATTEMPTS:
      return { ...state, ccAttempts: action.value };
    case Constants.FIVEG_LINE:
      return { ...state, fiveg_line: action.value };
    case Constants.IS_RESUME_FLOW:
      return { ...state, isResumeFlow: action.value };
    case Constants.REGSKIP:
      return { ...state, regSkip: action.value };
    case Constants.SHOW:
      return { ...state, show: action.value };
    // case Constants.COUNT:
    //   return { ...state, count: action.value };
    case Constants.DELIVERY_DATE:
      return { ...state, deliveryDate: action.value };
    case Constants.PAYMENT_CALL:
      return { ...state, paymentCall: action.value };
    case Constants.SHOW_EID:
      return { ...state, showEid: action.value };
    case Constants.BACK_ORDER:
      return { ...state, isBackOrder: action.value };
    case Constants.SET_RESUME_ABANDONED:
      return { ...state, isResumeAbandoned: action?.response };
    case 'API_LOADED':
      return { ...state, apiLoaded: action?.response };
    case 'TAGGING_API_LOADED':
      return { ...state, taggingApiLoaded: action?.response };
    case 'SIGNIN_CRADLE_VALUE':
      return { ...state, signInCradleValue: action?.response, apiCompleted: true };
    case 'CRADLE_API_COMPLETED':
      return { ...state, apiCompleted: action?.response };
    case 'JOINT_TRANSACTION_LINE':
      return { ...state, jointTransactionLine: action?.value };
    default:
      return state;
  }
}

export default SessionValues;
